export default "__VITE_ASSET__ezpMJqmt__"